module.exports = __webpack_public_path__ + "static/img/image_article_019.1e74c6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/article_img/image_article_019.png
// module id = nD3W
// module chunks = 0